import React, { Component } from 'react';

interface Props {
  isModalVisible;
  children;
}

class SFModal extends Component<Props, {}> {
  render() {
    return <div className="sf-chatmodal">{this.props.children}</div>;
  }
}

export default SFModal;
